import React from 'react'
import contactbanner from '../../images/shop.png'
import contactimg from '../../images/contat-us.jpg'
//import mapurl from 'https://codesandbox.io/'
import { Container, Row, Col} from 'react-bootstrap'
import Contactform from './Contactform' 


export default function Contact() {
  return (
    <>
    <div className="breadcrumb-banner" >
    <img src={contactbanner} className="img-fluid" alt="Shop"/>
  <div className="container-bread">
       <h1 className="text-white">
        Contact  Us
        </h1>
    </div>
  </div>


  <div className="google-maps">
  
  </div>


  <div className="contact-box pt-5 pb-5">
    <Container fluid>
    <Row>
    <Col md={6}>

      <img src={contactimg} className="img-fluid" alt=""/>
    
    
    </Col>

    <Col md={6}>
    <div className="aboutus-page">
    <Contactform/>
    </div>


    </Col>


    </Row>

    </Container>
  </div>
  

  </>
  )
}
